import axios from "axios";
import config from "../config";
const axiosInstance = axios.create({ baseURL: `${config.api_url}/api` });

const getRequestObj = (name, { query, params, payload }) => {
  let queryEncoded = "";
  let { leads } = config.endpoints;
  if (query) {
    const queryParams = new URLSearchParams(query);
    queryEncoded = queryParams.toString();
  }
  switch (name) {
    case "createLeads":
      return {
        url: `/${leads}/create`,
        method: "POST",
        data: payload,
      };
    case "test":
      return {
        url: `/${leads}/test`,
        method: "GET",
      };
    default:
      return null;
  }
};
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response.status === 401) {
    //   const { dispatch } = createdStore.store;
    //   dispatch(logoutUser());
    //   dispatch(clearModal());
    //   dispatch(getErrorMessage({ message: error.response.data }));
    // }
    return Promise.reject(error);
  }
);

const apiService = ({
  route,
  query,
  params,
  payload,
  authToken,
  headers = {},
  responseType = null,
  onDownloadProgress = null,
}) => {
  const requestObj = getRequestObj(route, { query, payload, params });

  return axiosInstance({
    ...requestObj,
    headers: {
      Authorization: `Bearer ${authToken}`,
      ...headers,
      // "Access-Control-Allow-Origin": "*"
    },
    responseType,
    onDownloadProgress,
  });
};

export default apiService;
